import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { StorageChangeKeyMatch, StorageChangeOrigin, } from "../../models/index.js";
export class PulseStorage {
    options;
    changes = new Subject();
    constructor(options) {
        this.options = options;
    }
    change(key, keyMatch = StorageChangeKeyMatch.Full, scope = StorageChangeOrigin.External) {
        let changes = this.changes.asObservable().pipe(filter(({ external }) => {
            if (scope === StorageChangeOrigin.All) {
                return true;
            }
            return scope === StorageChangeOrigin.External ? external : !external;
        }));
        if (key) {
            if (!keyMatch || keyMatch === StorageChangeKeyMatch.Full) {
                changes = changes.pipe(filter((change) => change.key === key));
            }
            else if (keyMatch === StorageChangeKeyMatch.Start) {
                changes = changes.pipe(filter((change) => change.key.startsWith(key)));
            }
            else {
                throw new Error('Invalid keyMatch value!');
            }
        }
        return changes;
    }
    getJSON(key) {
        const value = this.get(key);
        return typeof value === 'string' ? JSON.parse(value) : null;
    }
    setJSON(key, value) {
        const json = JSON.stringify(value);
        this.set(key, json);
    }
    getStorageKey(name) {
        const prefix = this.options.storagePrefix;
        if (!prefix) {
            return name;
        }
        return `${prefix}${name}`;
    }
    revertStorageKey(key) {
        const prefix = this.options.storagePrefix;
        if (!prefix?.length) {
            return key;
        }
        return key.slice(this.options.storagePrefix.length);
    }
    isStorageKey(name) {
        if (!this.options.storagePrefix || !name) {
            return true;
        }
        return name.startsWith(this.options.storagePrefix);
    }
    emitChange(change) {
        this.changes.next(change);
    }
}
//# sourceMappingURL=pulse-storage.js.map